import OpportunityTypeService from '@/services/OpportunityTypeService'

const createOpportunityTypesModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 999,
    total: 0,
    opportunityTypes: []
  },
  actions: {
    getOpportunityTypes: async ({ commit, state }) => {
      try {
        const data = await OpportunityTypeService.getOpportunityTypes(state.pageSize, state.page)
        if (!data.opportunityTypes) {
          return
        }

        commit('SET_OPPORTUNITYTYPES', {
          opportunityTypes: data.opportunityTypes
        })
        commit('SET_PAGES', { pages: data.pages })
        commit('SET_TOTAL', { total: data.total })
      } catch (err) {
        console.info('Failed to retrieve opportunity types', err)
      }
    },
    setPage: ({ dispatch, state }, page) => {
      state.page = page
      dispatch('getOpportunityTypes')
    }
  },
  getters: {
    opportunityTypes: (state) => state.opportunityTypes,
    allOpportunityTypes: (state) => state.opportunityTypes,
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_OPPORTUNITYTYPES: (state, { opportunityTypes }) => {
      state.opportunityTypes = opportunityTypes
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createOpportunityTypesModule
